import Brands from '../components/Brands';
import TickLabel from '../components/TickLabel';
import Hero from '../components/Hero';
import Footer from '../components/Footer';
import SectionHome from './../components/SectionHome';
import { logos } from './../components/dataCarrusel';


type Props = {}

function Home({ }: Props) {
    //const playerRef = useRef(null);

    const carruselLogos = [...logos, ...logos];

    return (
        <div className="w-screen relative flex flex-col items-center bg-black">
            
            {/*HeroSection*/}
            <div className='relative w-screen h-screen mb-0 xl:mb-10'>
                <Hero />
            </div>

            {/*Brands*/}
            <span className='text-grayText font-regular text-lg mb-4 xl:my-4'>Powered by Onxite</span>
            <div className='flex overflow-hidden w-full'>
                <div className='flex items-center whitespace-nowrap animate-scroll'>
                    {carruselLogos.map((logo, index) => (
                        <Brands logo={logo} key={index} />
                    ))}
                </div>
            </div>

            {/*Why Measure events?*/}
            <div className='flex flex-col xl:flex-row w-5/6 my-24'>
                <span className='font-bold text-white text-4xl self-center'>Why measure events?</span>
                <div className='flex flex-col mt-8 xl:mt-0'>
                    <TickLabel text={'Foster creativity through data-driven insights.'}/>
                    <TickLabel text={'Elevate event experiences with measurable outcomes.'}/>
                    <TickLabel text={'Optimize marketing efforts for greater impact.'}/>
                </div>
                <div className='xl:pl-14'>
                    <TickLabel text={'Make smarter decisions to shape future events.'}/>
                    <TickLabel text={'Enrich attendee engagement through strategic evaluation.'}/>
                </div>
            </div>

            {/*Img Section*/}
            <div className='w-screen h-screen my-0 mb-24'>
                <SectionHome />
            </div>

            {/*Footer*/}
            <div className='w-11/12 my-7'>
                <Footer />
            </div>
        </div>
    )
}

export default Home